import { environment } from '../../../environments/environment';

export class SystemConfig {

    static Constants = class {
        static readonly MAX_AMOUNTS_OF_BALLS = 22;

        static readonly LOCALE_EN = 'en';
        static readonly LOCALE_DE = 'de';
        static readonly LOCALE_MK = 'mk';
        static readonly LOCALE_RU = 'ru';

        static readonly LOCALE_DEFAULT = 'en';
        static readonly LOCALE_SEPARATOR = '.';
        static readonly LOCALE_ARGS = '#args';

        static readonly AMOUNT_OF_KENO_NUMBERS = 80;
    };

    static Endpoint = class {

        public static get baseUrl():string {
            return environment.endpoint + environment.api;
        }

        static readonly SIGNALR = '/signalr';
        static readonly LOGIN = environment.endpoint + '/Account/MobileLogin';
        static readonly LOGOUT = environment.endpoint + '/Account/LogOff';
        static readonly USER_ACCOUNT_SETTINGS = environment.endpoint + environment.api + '/UserAccountSettings';
        static readonly BALANCE = environment.endpoint + environment.api + '/AccountBalance';
        static readonly INITIAL_STATE = environment.endpoint + environment.api + '/KenoInitialState';
        static readonly WINNING_PLAN = environment.endpoint + environment.api + '/KenoWintable';
        static readonly SETTINGS = environment.endpoint + environment.api + '/KenoSettings';
        static readonly TICKET = environment.endpoint + environment.api + '/KenoTicket';
        static readonly TICKET_HISTORY = environment.endpoint + environment.api + '/KenoTicketHistory';
        static readonly TICKET_DISBURSE = environment.endpoint + environment.api + '/KenoTicketDisburse';
        static readonly PAYIN = environment.endpoint + environment.api + '/RedeemVoucher';
        static readonly PAYOUT = environment.endpoint + environment.api + '/CreateCashTicket';
        static readonly TRANSACTION_LIST = environment.endpoint + environment.api + '/UserAccountFinancialOperationList';
        static readonly STORNO_TRANSACTION = environment.endpoint + environment.api + '/CancelCashTicket';
    };

    static Asset = class {
        static readonly TRANSLATION_DE = environment.path + '/assets/lang/de.json';
        static readonly TRANSLATION_EN = environment.path + '/assets/lang/en.json';
        static readonly TRANSLATION_MK = environment.path + '/assets/lang/mk.json';
        static readonly TRANSLATION_RU = environment.path + '/assets/lang/ru.json';
        static readonly FLAGS = environment.path + '/assets/Flags/64/';
    };
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/shared/config/system-config.ts